import { defineStore } from 'vue_features/shared/composables/store_helpers'
import { reactive } from 'vue'
import remove from 'lodash/remove'
import { useNamespacedEventListener } from 'vue_features/shared/composables/index'

export const useGlobalTopSticky = defineStore('globalTopSticky', () => {
  const state = reactive({
    topStickies: [],
  })

  function addSticky(stickyElement) {
    state.topStickies.push(stickyElement)
    updateStyles()
  }

  function removeSticky(stickyElement) {
    remove(state.topStickies, (el) => el === stickyElement)
  }

  const updateStyles = () => {
    let top = 0
    state.topStickies.forEach((sticky) => {
      if (!sticky || !sticky.value) {
        return
      }

      sticky.value.style.top = `${top}px`
      const heightStr = window.getComputedStyle(sticky.value).height
      const height = parseFloat(heightStr)

      if (!Number.isNaN(height)) {
        top += height
      }
    })
  }

  const { on: winOn } = useNamespacedEventListener(window)
  const RESIZE = 'resize.top-sticky'

  winOn(RESIZE, updateStyles)

  return { state, addSticky, removeSticky }
})
